/* import __COLOCATED_TEMPLATE__ from './procedure-dependencies-modal.hbs'; */
/* RESPONSIBLE TEAM: team-knowledge-foundations */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import type IntlService from 'ember-intl/services/intl';
import type AppService from 'embercom/services/app-service';

interface DependentProcedure {
  id: number;
  name: string;
}

interface ContentConflict {
  content_id: number;
  content_type: number;
  dependent_procedures: DependentProcedure[];
}

interface Args {
  confirmContext: {
    conflicts: ContentConflict[];
    action: 'delete' | 'unpublish';
  };
}

interface Signature {
  Args: Args;
}

export default class ProcedureDependenciesModal extends Component<Signature> {
  @service intl!: IntlService;
  @service intercomConfirmService: any;
  @service appService!: AppService;

  get action() {
    return this.args.confirmContext?.action;
  }

  get procedures() {
    let conflicts = this.args.confirmContext?.conflicts;
    if (!conflicts || conflicts.length === 0) {
      return [];
    }
    // TODO: Handle multiple conflicts for Bulkcommands
    // For singular commands, there will be only one conflict
    let dependentProcedure = conflicts[0];
    if (!dependentProcedure || !dependentProcedure.dependent_procedures) {
      return [];
    }

    let appId = this.appService.app.id;
    return dependentProcedure.dependent_procedures.map((procedure) => ({
      ...procedure,
      url: `/a/apps/${appId}/automation/fin-ai-agent/procedures/${procedure.id}`,
    }));
  }

  get warning() {
    return this.intl.t('content-service.procedure-dependencies-modal.warning', {
      action: this.action,
    });
  }

  get message() {
    let count = this.args.confirmContext?.conflicts?.length || 0;

    return this.intl.t('content-service.procedure-dependencies-modal.message', {
      count,
    });
  }

  get closeButtonText() {
    return this.intl.t('content-service.procedure-dependencies-modal.close');
  }

  @action closeModal() {
    this.intercomConfirmService.reject({ closed: true });
    this.intercomConfirmService.closeConfirm();
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'ContentService::ProcedureDependenciesModal': typeof ProcedureDependenciesModal;
    'content-service/procedure-dependencies-modal': typeof ProcedureDependenciesModal;
  }
}
